class CgDimensions extends HTMLElement {
  connectedCallback() {
    this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.unit = 'cm';
    this.person = true;
    this.render();
    this.addEventListener('click', e => {
      const unit = e.target.closest('[data-unit]');
      if (unit) { this.unit = unit.dataset.unit; this.render(); }
      if (e.target.closest('[data-person]')) { this.person = !this.person; this.render(); }
    });
    this.querySelector('[data-wall]')?.addEventListener('input', e => this.fit(e.target.value));
    document.addEventListener('variant:change', e => {
      const variant = this.data.variants?.find(v => String(v.id) === String(e.detail?.variant?.id));
      if (variant) { this.data = {...this.data, ...variant}; this.render(); }
    });
  }
  n(v) { return this.unit === 'in' ? `${(Number(v)/2.54).toFixed(1)} in` : `${Number(v).toFixed(1).replace('.0','')} cm`; }
  render() {
    const d=this.data, max=Math.max(d.largo||1,d.alto||1,d.fondo||1,170), scale=360/max;
    this.querySelectorAll('[data-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.unit===this.unit)));
    this.querySelectorAll('[data-measure]').forEach(el=>el.textContent=this.n(d[el.dataset.measure]||0));
    const svg=this.querySelector('svg'), w=(d.largo||100)*scale, h=(d.alto||80)*scale, depth=(d.fondo||60)*scale;
    if(svg){
      svg.setAttribute('aria-label',`Mueble de ${this.n(d.largo)} de largo, ${this.n(d.alto)} de alto y ${this.n(d.fondo)} de fondo`);
      svg.querySelector('[data-front]').setAttribute('d',`M 110 ${455-h} h ${w} v ${h} h -${w} Z`);
      svg.querySelector('[data-side]').setAttribute('d',`M 520 ${455-h} h ${depth} v ${h} h -${depth} Z`);
      svg.querySelector('[data-person]').style.display=this.person?'':'none';
      svg.querySelector('[data-long-label]').textContent=this.n(d.largo);
      svg.querySelector('[data-depth-label]').textContent=this.n(d.fondo);
      svg.querySelector('[data-height-label]').textContent=this.n(d.alto);
    }
    const tip=this.querySelector('[data-passage]'); if(tip) tip.textContent=this.n((Number(d.fondo)||0)+5);
    this.fit(this.querySelector('[data-wall]')?.value);
  }
  fit(value) {
    const out=this.querySelector('[data-fit]'); if(!out||!value){ if(out) out.textContent=''; return; }
    const delta=Number(value)-Number(this.data.largo||0);
    out.className=delta>=0?'cg-fit cg-fit--yes':'cg-fit cg-fit--no';
    out.textContent=delta>=0?`Sí cabe · te sobran ${this.n(delta)}`:`No cabe · te faltan ${this.n(Math.abs(delta))}`;
  }
}
customElements.define('cg-dimensions', CgDimensions);

document.addEventListener('DOMContentLoaded', () => {
  const pattern = /^(?:-\s*)?(?:medidas?|largo|ancho|alto|altura|profundidad|dimensiones)\b/i;
  document.querySelectorAll('[data-cg-description-clean]').forEach(container => {
    [...container.querySelectorAll('p, li, div')].forEach(element => {
      if (pattern.test(element.textContent.trim())) {
        element.remove();
        return;
      }
      if (/<br\s*\/?\s*>/i.test(element.innerHTML)) {
        const kept = element.innerHTML.split(/<br\s*\/?\s*>/i).filter(part => {
          const probe = document.createElement('span');
          probe.innerHTML = part;
          return !pattern.test(probe.textContent.trim());
        });
        element.innerHTML = kept.join('<br>');
      }
    });
  });
});

class CgMegaNav extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.cg-mega')];
    this.items.forEach((item) => {
      const toggle = item.querySelector('.cg-mega__toggle');
      const link = item.querySelector('.cg-mega__link');
      toggle.addEventListener('click', () => this.setOpen(item, !item.classList.contains('is-open')));
      item.addEventListener('mouseenter', () => toggle.setAttribute('aria-expanded', 'true'));
      item.addEventListener('mouseleave', () => {
        if (!item.classList.contains('is-open')) toggle.setAttribute('aria-expanded', 'false');
      });
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.setOpen(item, false);
          link.focus();
        } else if (event.key === 'ArrowDown' && (event.target === link || event.target === toggle)) {
          event.preventDefault();
          this.setOpen(item, true);
          item.querySelector('.cg-mega__content a')?.focus();
        }
      });
      item.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!item.contains(document.activeElement)) this.setOpen(item, false);
        });
      });
    });
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.items.forEach((item) => this.setOpen(item, false));
    });
  }

  setOpen(item, open) {
    if (open) this.items.forEach((other) => other !== item && this.setOpen(other, false));
    item.classList.toggle('is-open', open);
    item.querySelector('.cg-mega__toggle').setAttribute('aria-expanded', String(open));
  }
}
customElements.define('cg-mega-nav', CgMegaNav);
